const placeholdes = {
  "org_name": "ByPal",
  "commnity_type": "All ByPal",
  "community_url": "www.bypal.net",
  "zone_name": "www.ByPal.net"
}

module.exports = placeholdes;
